import SvgIcon from 'material-ui/SvgIcon';
import React from 'react';

const ThreeDots = (props) => (
  <SvgIcon {...props}>
    <circle fill={props.color} cx="12" cy="12" r="2"/>
    <circle fill={props.color} cx="18" cy="12" r="2"/>
    <circle fill={props.color} cx="6" cy="12" r="2"/>
  </SvgIcon>
);



export default ThreeDots;



// WEBPACK FOOTER //
// ./src/icons/ThreeDots.jsx